// extracted by mini-css-extract-plugin
export default {"main_css_us":"SecondaryFormLabel_main_css_us__vZXN1","main_css_jp":"SecondaryFormLabel_main_css_jp__FlU3U","text":"SecondaryFormLabel_text__BhK9B"};